import React from 'react';
import ReactDOM from 'react-dom';

import App from 'src/App';


const bootstrapApplication = ({ libraryName }) => {
  const root = document.querySelector(`#${libraryName}-markup`);
  if (!root) return false;

  return ReactDOM.hydrate(<App />, root);
};

export default bootstrapApplication;
